<template>

  <aside class="mt-10 mb-3 border-b border-red-200">
    <h3 class="text-lg ">
<!--      <span v-if="!showType && maintype !== 10 && maintype !== 16" v-text="setDruckType.label[lang]"></span>-->
      <span v-if="!showMain" v-text="setMainType.label[lang]"></span> {{ setMatText.header_configuration[lang] }}
    </h3>
    <nav class="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-6 items-end mb-5">
      <div>
        <label class="block text-sm font-medium "
               for="settpnum"
        >{{ setMatText.select_label_sheath_mat[lang] }}</label>

        <select v-model="setSheathMaterial"
                class="input-md w-full"
        >
          <option v-for="material in sheathmaterials"
                  :value="material.id"
                  v-text="material.value"
          ></option>
        </select>

      </div>

      <div>
        <label class="block text-sm font-medium "
               for="settpnum"
        >{{ setMatText.select_label_sheath_dia[lang] }}</label>

        <select v-model="setDiameter"
                class="input-md w-full"
        >
          <option v-for="diameter in diameters"
                  :value="diameter"
                  v-text="`${diameter} mm`"
          ></option>
        </select>

      </div>

      <div>
        <label class="block text-sm font-medium "
               for="settpnum"
        >{{ setMatText.input_label_set_tp_num[lang] }}</label>

        <select v-model="settpnum"
                class="input-md w-full"
        >
          <option v-for="tpnum in tpnums"
                  :value="tpnum.value[lang]"
                  v-text="tpnum.value[lang]"
          ></option>
        </select>

      </div>

      <div>
        <label class="block text-sm font-medium "
               for="settptype"
        >{{ setMatText.input_label_set_type_tp[lang] }}</label>
        <select v-model="settptype"
                class="input-md w-full"
        >
          <option v-for="tptype in tptypes"
                  :value="tptype.short"
                  v-text="tptype.value"
          ></option>
        </select>
      </div>

      <div>
        <label class="block text-sm font-medium "
               for="setlength"
        >{{ setMatText.input_label_length[lang] }}</label>
        <select v-model="setlength"
                class="input-md w-full"
        >
          <option v-for="nlength in nlengths"
                  :value="nlength"
                  v-text="nlength"
          />
        </select>
      </div>

    </nav>

    <nav class="grid grid-cols-1 sm:grid-cols-4 gap-6 items-end mb-5">
      <div v-bind:class="{'lg:col-span-2':setfitting !== 99}">
        <label class="block text-sm font-medium "
               for="setfitting"
        >{{ setMatText.select_label_assembly[lang] }}</label>
        <select v-model="setfitting"
                class="input-md w-full"
                :class="{'animate-bounce border-red-500':isSelected}"
                v-on:change="otherFitting = ''"
        >
          <option v-for="fitting in fittings"
                  :value="fitting.id"
                  v-text="fitting.value[lang]"
          />
        </select>
      </div>

      <div v-show="setfitting === 99"
           class="lg:col-span-2"
      >
        <label class="block text-sm font-medium "
               for="setfitting"
        >{{ setMatText.select_label_fitting_alt[lang] }}</label>
        <input v-model="otherFitting"
               class="input-md w-full"
               type="text"
        >
      </div>

      <button class="button-set col-span-1"
              type="button"
              @click="addSpec()"
      ><span class="inline mx-3">{{ setMatText.btn_label_add_specification[lang] }}</span>
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 384 512"
             class="w-3 h-3 sm:w-4 sm:h-4 text-red-500"
        ><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
          <path d="M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z"
                style="fill:currentColor"
          />
        </svg>

      </button>

    </nav>

  </aside>

</template>
<script setup>

import {ref} from "vue";
import setMatText from "../../lang/setMaterials.json";
import {drucktypes, fittingList, maintypes, tptypes, tpnums} from "../configs/config-main";

const props = defineProps({
  maintype: {
    type: Number,
    default: 8
  },
  drucktype: {
    type: Number,
    default: 4
  },
  showMain:{
    type:Boolean,
    default:false
  },
  showType:{
    type:Boolean,
    default:false
  },
  fittype: {
    type: Array,
    default: ['all']
  },
  selectfitting: [Number],
  lang: {
    type: String,
    default: 'de'
  }
})

const emits = defineEmits(['setnewpostext'])

const setNewPosText = ref('')
const setMainType = ref()
const setDruckType = ref()
const selectDruckTyp = ref()
const fittings = ref([])


const settpnum = ref(setMatText.tpNumSingle[props.lang])
const setlength = ref(1000)
const settptype = ref('K')
const setfitting = ref(0)
const setDiameter = ref(3.0)
const setSheathMaterial = ref(2)
const nlengths = ref([50, 100, 150, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 1500, 2000, 2500, 3000])
const diameters = ref([1.0, 1.5, 2.0, 2.5, 3.0, 4.0, 4.5, 5, 6, 8])
const isSelected = ref(false)

const sheathmaterials = {
  1: {id: 1, short: '01', value: 'W1.4751'},
  2: {id: 2, short: '02', value: 'W2.4816'},
  3: {id: 3, short: '03', value: 'Parentmetal'},
  4: {id: 4, short: '04', value: 'PtRh10'},
}



const otherFitting = ref('');
const drucktyp = ref('')
const maintype = ref('')

for (let mtype of maintypes.value) {
  if (mtype.id === props.maintype) {
    setMainType.value = mtype
  }
}

for (let dtype of drucktypes.value) {
  if (dtype.id === props.drucktype) {
    setDruckType.value = dtype
    selectDruckTyp.value = dtype.id
  }
}


/**
 *  Fittings
 */

fittings.value.push({id: 0, short: '-', value: setMatText.select_label_fitting});

if (props.fittype.includes('sr')) {
  fittings.value.push(
      fittingList.SR22SR4751,
      fittingList.SR15SR4751,
      fittingList.SR20SR4751,
      fittingList.SR22SR4841,
      fittingList.SR15SR4841,
      fittingList.SR20SR4841,
      fittingList.SR22SR4816,
      fittingList.SR15SR4816,
      fittingList.SR20SR4816,
  )
}

if (props.fittype.includes('con')) {
  fittings.value.push(
      fittingList.BL20,
      fittingList.BL30,
      fittingList.MCS,
      fittingList.MCSH,
      fittingList.MCSU,
      fittingList.MCSC,
      fittingList.SCS,
      fittingList.SCSH,
      fittingList.SCSU,
      fittingList.SCSC
  )
}

if (props.fittype.includes('bla')) {
  fittings.value.push(
      fittingList.BL15,
      fittingList.BL20,
      fittingList.BL30,
  )
}

if (props.fittype.includes('sc')) {
  fittings.value.push(
      fittingList.SCS,
      fittingList.SCSH,
      fittingList.SCSU,
      fittingList.SCSC
  )
}

if (props.fittype.includes('mc')) {
  fittings.value.push(
      fittingList.MCS,
      fittingList.MCSH,
      fittingList.MCSU,
      fittingList.MCSC,
  )
}


if (props.fittype.includes('agl')) {
  fittings.value.push(
      fittingList.ALBL20,
      fittingList.ALBL30,
      fittingList.ALMC,
      fittingList.ALSC,
      fittingList.ALLS,
      fittingList.TLBL20,
      fittingList.TLBL30,
      fittingList.TLSC,
      fittingList.TLMC,
      fittingList.TLLS,
  )
}

if (props.fittype.includes('ba')) {
  fittings.value.push(
      fittingList.BA,
      fittingList.BG12,
      fittingList.BG38,
  );
}

if (props.fittype.includes('all')) {
  fittings.value.push(
      fittingList.BL20,
      fittingList.BL30,
      fittingList.MCS,
      fittingList.MCSH,
      fittingList.MCSU,
      fittingList.MCSC,
      fittingList.SCS,
      fittingList.SCSH,
      fittingList.SCSU,
      fittingList.SCSC,
      fittingList.ALBL20,
      fittingList.ALBL30,
      fittingList.ALMC,
      fittingList.ALSC,
      fittingList.ALLS,
      fittingList.TLBL20,
      fittingList.TLBL30,
      fittingList.BA,
      fittingList.BG12,
      fittingList.SR22SR4751,
      fittingList.SR15SR4751,
      fittingList.SR20SR4751,
      fittingList.SR22SR4841,
      fittingList.SR15SR4841,
      fittingList.SR20SR4841,
      fittingList.SR22SR4816,
      fittingList.SR15SR4816,
      fittingList.SR20SR4816,
  );
}



fittings.value.push(
    {id: 99, short: 'custom', value: setMatText.select_label_fitting_alt},
);

const addSpec = () => {

  if (setfitting.value === 0) {
    isSelected.value = true;
    setTimeout(()=>isSelected.value = false,500)
    return false;
  }


  let typefitting = {short: 'definierten'}


  if (setfitting.value !== 99 && otherFitting.value === '') {
    for (let item of fittings.value) {
      if (item.id === setfitting.value) typefitting = item
    }

  } else {
    typefitting = {short: otherFitting.value}
  }

  setNewPosText.value = setMainType.value.label[props.lang]
      + ' ' + setMatText.set_postext_with[props.lang]
      + ' Ø' + setDiameter.value
      + ' mm ' + setMatText.select_label_sheath_dia[props.lang]
      + ' ' + sheathmaterials[setSheathMaterial.value].value
      + ' ' + setMatText.select_label_sheath_mat[props.lang]
      + ', ' + typefitting.short
      + ' ' + setMatText.set_postext_assembly[props.lang]
      + ', ' + settpnum.value
      + ' ' + setMatText.select_label_type[props.lang]
      + ' ' + settptype.value
      + ' ' + setMatText.set_postext_and[props.lang]
      + ' ' + setlength.value
      + ' mm ' +setMatText.set_postext_nl[props.lang]


  emits('setnewpostext', setNewPosText.value)

}

</script>